interface CheckIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  stroke?: string;
}

const CheckIcon = ({
  width = 24,
  height = 24,
  fill = "#EC6F7F",
  stroke = "#EC6F7F",
}: CheckIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.28"
      d="M15.9992 29.3316C23.3625 29.3316 29.3317 23.3625 29.3317 15.9991C29.3317 8.63583 23.3625 2.66669 15.9992 2.66669C8.63589 2.66669 2.66675 8.63583 2.66675 15.9991C2.66675 23.3625 8.63589 29.3316 15.9992 29.3316Z"
      fill={fill}
    />
    <path
      d="M29.1636 6.38769L28.0089 7.17624C23.3386 10.3658 19.4531 14.5742 16.6456 19.4841L16.1219 20.3998L11.0589 14.5426M29.1133 13.5755C30.0081 18.4349 28.1551 23.6038 23.9101 26.7325C17.9828 31.1011 9.63622 29.8374 5.26762 23.9101C0.899024 17.9827 2.16266 9.63616 8.09003 5.26756C12.3349 2.13897 17.8206 1.89902 22.1973 4.19199"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckIcon;
